const toggleButtons = document.querySelectorAll('.password__see[type="button"]');

if (toggleButtons) {
    toggleButtons.forEach((button) => {
        const inputId = button.getAttribute('data-input-id') || button.id.replace('togglePassword', '');
        const input = document.getElementById(`${inputId}`);

        if (!input) return;
        
        button.addEventListener('click', () => {
            const isVisible = input.type === 'text';
            input.type = isVisible ? 'password' : 'text';
            button.classList.toggle('show-eye'); 
        });
    });
}
